module.exports = ($scope, $event) => {

    // Dodaj właściwość do formularza, że miał być wysłany.
    $scope.conForm.$requested = true;

    // Jeżeli jednak nie jest poprawnie uzupełniony, to go nie wysyłaj.
    if ($scope.conForm.$valid == false){
        $event.preventDefault();
        return false;
    }

    // Jeśli wszystko ok, to zapisz odpowiedź do JSONa.
    $scope.answer = JSON.stringify($scope.state);
};